import { makeStyles } from '@material-ui/core/styles';

// Branch ring spinner. The intrinsic design size is 112px; callers override
// via the `--spinner-size` CSS custom property on a parent (set in spinner.jsx
// from the `size` prop). The SVG scales naturally via its viewBox; the center
// box scales proportionally via calc().
const styles = () => ({
  '@keyframes branchSpinRotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  },
  '@keyframes branchSpinTrimLength': {
    '0%, 100%': { strokeDasharray: '290 24' },
    '50%': { strokeDasharray: '130 184' }
  },
  '@keyframes branchSpinTrimOffset': {
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: -314 }
  },
  wrap: {
    width: 'var(--spinner-size, 112px)',
    height: 'var(--spinner-size, 112px)',
    position: 'relative',
    display: 'inline-grid',
    placeItems: 'center'
  },
  svg: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%'
  },
  ringBase: {
    fill: 'none',
    stroke: 'rgba(114, 120, 50, 0.5)',
    strokeWidth: 5
  },
  ringArc: {
    fill: 'none',
    stroke: '#727832',
    strokeWidth: 5,
    strokeLinecap: 'round',
    transformOrigin: '56px 56px',
    animation:
      '$branchSpinRotate 1.7s linear infinite, $branchSpinTrimLength 1.7s ease-in-out infinite, $branchSpinTrimOffset 1.7s linear infinite'
  },
  center: {
    width: 'calc(var(--spinner-size, 112px) * 80 / 112)',
    height: 'calc(var(--spinner-size, 112px) * 96 / 112)',
    objectFit: 'contain',
    pointerEvents: 'none'
  }
});

export default makeStyles(styles);
